// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__QiwEd","anime":"Loading_anime__3k0EH","upDown":"Loading_upDown__36A7t","text":"Loading_text__1L82d"};